function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "path-1",
  cx: 15,
  cy: 15,
  r: 14.3181818
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-3",
  points: "0.00600160612 0.67592042 45.6878198 0.67592042 45.6878198 31.3577386 0.00600160612 31.3577386"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-5",
  points: "0 0 40.9090909 0 40.9090909 27.2727273 0 27.2727273"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-7",
  points: "0.0783843343 0.563499489 54.6238389 0.563499489 54.6238389 36.6998631 0.0783843343 36.6998631"
}), /*#__PURE__*/React.createElement("circle", {
  id: "path-9",
  cx: 15,
  cy: 15,
  r: 14.3181818
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-11",
  points: "0.00600160612 0.67592042 45.6878198 0.67592042 45.6878198 31.3577386 0.00600160612 31.3577386"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-13",
  points: "0 0 40.9090909 0 40.9090909 27.2727273 0 27.2727273"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-15",
  points: "0.0783843343 0.563499489 54.6238389 0.563499489 54.6238389 36.6998631 0.0783843343 36.6998631"
}), /*#__PURE__*/React.createElement("circle", {
  id: "path-17",
  cx: 15,
  cy: 15,
  r: 14.3181818
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-19",
  points: "0.00600160612 0.67592042 45.6878198 0.67592042 45.6878198 31.3577386 0.00600160612 31.3577386"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-21",
  points: "0 0 40.9090909 0 40.9090909 27.2727273 0 27.2727273"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-23",
  points: "0.0783843343 0.563499489 54.6238389 0.563499489 54.6238389 36.6998631 0.0783843343 36.6998631"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Design",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-12"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#00D0C1",
  fillOpacity: 0.161549388,
  fill: "#00CFC0",
  cx: 402,
  cy: 65,
  r: 21.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#979797",
  fill: "#FFFFFF",
  x: 162.5,
  y: 0.5,
  width: 130,
  height: 127,
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#00D0C1",
  fillOpacity: 0.161549388,
  fill: "#00CFC0",
  x: 178.5,
  y: 22.5,
  width: 99,
  height: 15,
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#00D0C1",
  fillOpacity: 0.161549388,
  fill: "#00CFC0",
  x: 178.5,
  y: 45.5,
  width: 99,
  height: 15,
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#00D0C1",
  fillOpacity: 0.161549388,
  fill: "#00CFC0",
  x: 178.5,
  y: 68.5,
  width: 99,
  height: 15,
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#EF3131",
  fill: "#FFDFDF",
  x: 178.5,
  y: 91.5,
  width: 99,
  height: 15,
  rx: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M36,19.022715 C75.9767819,18.3564089 114.643449,32.3488372 152,61",
  id: "Path-2",
  stroke: "#979797"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36,62.022715 C75.9767819,61.3564089 114.643449,75.3488372 152,104",
  id: "Path-2",
  stroke: "#979797",
  transform: "translate(94.000000, 83.000000) scale(1, -1) translate(-94.000000, -83.000000) "
}), /*#__PURE__*/React.createElement("line", {
  x1: 36.5,
  y1: 61.5,
  x2: 151.5,
  y2: 61.5,
  id: "Line-5",
  stroke: "#979797",
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("line", {
  x1: 299.5,
  y1: 64.5,
  x2: 364,
  y2: 65,
  id: "Line-5",
  stroke: "#979797",
  strokeLinecap: "square",
  strokeDasharray: 5
}), /*#__PURE__*/React.createElement("g", {
  id: "Fill-1",
  transform: "translate(390.000000, 52.000000)",
  fill: "#000000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.7674,2.0004 L14.7674,4.6304 L9.1074,4.6304 L9.1074,2.0004 L7.1074,2.0004 L7.1074,4.6304 L2.0004,4.6304 L2.0004,21.9744 L21.9994,21.9744 L21.9994,4.6304 L16.7674,4.6304 L16.7674,2.0004 L14.7674,2.0004 Z M3.9994,8.9934 L19.9994,8.9934 L19.9994,6.6304 L3.9994,6.6304 L3.9994,8.9934 Z M3.9994,19.9744 L19.9994,19.9744 L19.9994,10.9924 L3.9994,10.9924 L3.9994,19.9744 Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "big-user-circle",
  transform: "translate(0.000000, 85.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0.681818, 0.681818)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Oval",
  fill: "#7060DF",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  mask: "url(#mask-2)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3.068182, -4.090909)",
  id: "color/black"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-9",
  fill: "#FBAF5B",
  x: 0,
  y: 0,
  width: 36.8181818,
  height: 38.1818182
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  mask: "url(#mask-2)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(27.753799, 9.083082) rotate(179.000000) translate(-27.753799, -9.083082) translate(4.367436, -7.064645)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2",
  stroke: "none",
  fill: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group-3-Copy-2",
  mask: "url(#mask-2)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(5.039662, 11.085943) rotate(331.000000) translate(-5.039662, -11.085943) translate(-15.562610, -2.834512)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-6",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2",
  stroke: "none",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.9653399,0.731743328 C21.7338016,4.92212982 18.7854076,11.8255229 8.02858693,14.3915242 C-1.75821724,16.7260285 -4.12610595,26.3668478 9.64244979,27.1765985 C23.4105202,27.9868375 35.2523906,23.6575041 39.4336302,14.8569599 C43.6148698,6.05641567 38.3167886,-2.60518158 30.9653399,0.731743328",
  id: "Fill-1",
  stroke: "none",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  opacity: 0.223400298,
  mask: "url(#mask-6)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group-3-Copy",
  mask: "url(#mask-2)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(13.405221, 30.201907) rotate(70.000000) translate(-13.405221, -30.201907) translate(-14.435688, 11.826907)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-8",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-7"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2",
  stroke: "none",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.3655041,1.5330594 C29.0567865,7.0853215 25.1255945,16.2323174 10.7831669,19.632269 C-2.26590532,22.7254873 -5.42309027,35.4995728 12.9349841,36.5724925 C31.2924112,37.6460592 47.0815718,31.9096924 52.6565579,20.2489713 C58.2315441,8.58825025 51.1674358,-2.8883661 41.3655041,1.5330594",
  id: "Fill-1",
  stroke: "none",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  opacity: 0.304896763,
  mask: "url(#mask-8)"
}))), /*#__PURE__*/React.createElement("text", {
  id: "FG",
  mask: "url(#mask-2)",
  fontFamily: "Poppins-SemiBold, Poppins",
  fontSize: 8.57142857,
  fontWeight: 500,
  "line-spacing": 8.57142857
})), /*#__PURE__*/React.createElement("g", {
  id: "big-user-circle",
  transform: "translate(0.000000, 46.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0.681818, 0.681818)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-10",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-9"
})), /*#__PURE__*/React.createElement("use", {
  id: "Oval",
  fill: "#7060DF",
  xlinkHref: "#path-9"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  mask: "url(#mask-10)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3.068182, -4.090909)",
  id: "color/black"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-10",
  fill: "#F7DB3A",
  x: 0,
  y: 0,
  width: 36.8181818,
  height: 38.1818182
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  mask: "url(#mask-10)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(27.753799, 9.083082) rotate(179.000000) translate(-27.753799, -9.083082) translate(4.367436, -7.064645)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-12",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-11"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2",
  stroke: "none",
  fill: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group-3-Copy-2",
  mask: "url(#mask-10)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(5.039662, 11.085943) rotate(331.000000) translate(-5.039662, -11.085943) translate(-15.562610, -2.834512)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-14",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-13"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2",
  stroke: "none",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.9653399,0.731743328 C21.7338016,4.92212982 18.7854076,11.8255229 8.02858693,14.3915242 C-1.75821724,16.7260285 -4.12610595,26.3668478 9.64244979,27.1765985 C23.4105202,27.9868375 35.2523906,23.6575041 39.4336302,14.8569599 C43.6148698,6.05641567 38.3167886,-2.60518158 30.9653399,0.731743328",
  id: "Fill-1",
  stroke: "none",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  opacity: 0.223400298,
  mask: "url(#mask-14)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group-3-Copy",
  mask: "url(#mask-10)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(13.405221, 30.201907) rotate(70.000000) translate(-13.405221, -30.201907) translate(-14.435688, 11.826907)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-16",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-15"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2",
  stroke: "none",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.3655041,1.5330594 C29.0567865,7.0853215 25.1255945,16.2323174 10.7831669,19.632269 C-2.26590532,22.7254873 -5.42309027,35.4995728 12.9349841,36.5724925 C31.2924112,37.6460592 47.0815718,31.9096924 52.6565579,20.2489713 C58.2315441,8.58825025 51.1674358,-2.8883661 41.3655041,1.5330594",
  id: "Fill-1",
  stroke: "none",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  opacity: 0.304896763,
  mask: "url(#mask-16)"
}))), /*#__PURE__*/React.createElement("text", {
  id: "FG",
  mask: "url(#mask-10)",
  fontFamily: "Poppins-SemiBold, Poppins",
  fontSize: 8.57142857,
  fontWeight: 500,
  "line-spacing": 8.57142857
})), /*#__PURE__*/React.createElement("g", {
  id: "big-user-circle",
  transform: "translate(0.000000, 7.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0.681818, 0.681818)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-18",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-17"
})), /*#__PURE__*/React.createElement("use", {
  id: "Oval",
  fill: "#7060DF",
  xlinkHref: "#path-17"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  mask: "url(#mask-18)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3.068182, -4.090909)",
  id: "color/black"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-7",
  fill: "#7060DF",
  x: 0,
  y: 0,
  width: 36.8181818,
  height: 38.1818182
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  mask: "url(#mask-18)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(27.753799, 9.083082) rotate(179.000000) translate(-27.753799, -9.083082) translate(4.367436, -7.064645)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-20",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-19"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2",
  stroke: "none",
  fill: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group-3-Copy-2",
  mask: "url(#mask-18)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(5.039662, 11.085943) rotate(331.000000) translate(-5.039662, -11.085943) translate(-15.562610, -2.834512)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-22",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-21"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2",
  stroke: "none",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.9653399,0.731743328 C21.7338016,4.92212982 18.7854076,11.8255229 8.02858693,14.3915242 C-1.75821724,16.7260285 -4.12610595,26.3668478 9.64244979,27.1765985 C23.4105202,27.9868375 35.2523906,23.6575041 39.4336302,14.8569599 C43.6148698,6.05641567 38.3167886,-2.60518158 30.9653399,0.731743328",
  id: "Fill-1",
  stroke: "none",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  opacity: 0.223400298,
  mask: "url(#mask-22)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group-3-Copy",
  mask: "url(#mask-18)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(13.405221, 30.201907) rotate(70.000000) translate(-13.405221, -30.201907) translate(-14.435688, 11.826907)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-24",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-23"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2",
  stroke: "none",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.3655041,1.5330594 C29.0567865,7.0853215 25.1255945,16.2323174 10.7831669,19.632269 C-2.26590532,22.7254873 -5.42309027,35.4995728 12.9349841,36.5724925 C31.2924112,37.6460592 47.0815718,31.9096924 52.6565579,20.2489713 C58.2315441,8.58825025 51.1674358,-2.8883661 41.3655041,1.5330594",
  id: "Fill-1",
  stroke: "none",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  opacity: 0.304896763,
  mask: "url(#mask-24)"
}))), /*#__PURE__*/React.createElement("text", {
  id: "FG",
  mask: "url(#mask-18)",
  fontFamily: "Montserrat-SemiBold, Montserrat",
  fontSize: 8.57142857,
  fontWeight: 500,
  "line-spacing": 8.57142857
}))));

var SvgSuccessFlow = function SvgSuccessFlow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "424px",
    height: "128px",
    viewBox: "0 0 424 128",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuccessFlow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/success-flow.58e37240.svg";
export { ForwardRef as ReactComponent };